module.exports = __webpack_public_path__ + "static/media/wallpaper.03075f9e.jpg";